import React from "react";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-mtk-bg border-t border-mtk-border overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 relative z-10">
        <div className="grid md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-heading text-2xl font-black tracking-[0.2em] text-white">MTK</span>
              <span className="font-mono-mtk text-[10px] tracking-[0.3em] text-mtk-gold uppercase">SYSTEM</span>
            </div>
            <p className="font-mono-mtk text-[11px] tracking-[0.25em] uppercase text-mtk-gold/80 mt-3">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-zinc-400 text-base leading-relaxed max-w-xl">
              {t.footer.copy}
            </p>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2 font-mono-mtk text-[11px] tracking-[0.2em] uppercase">
              <a href="#pillars" className="text-zinc-500 hover:text-mtk-gold transition-colors">{t.nav.pillars}</a>
              <a href="#services" className="text-zinc-500 hover:text-mtk-gold transition-colors">{t.nav.services}</a>
              <a href="#apply" className="text-zinc-500 hover:text-mtk-gold transition-colors">{t.nav.apply}</a>
              <a href="/admin/login" className="text-zinc-500 hover:text-mtk-gold transition-colors">{t.nav.admin}</a>
            </div>
          </div>
        </div>
      </div>

      <div className="relative">
        <div
          aria-hidden
          className="select-none pointer-events-none absolute -bottom-6 md:-bottom-10 inset-x-0 text-center font-heading font-black tracking-tighter text-[18vw] leading-none text-white/[0.025]"
        >
          MTK SYSTEM
        </div>
      </div>

      <div className="relative z-10 border-t border-white/5 max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row gap-2 justify-between text-[11px] font-mono-mtk uppercase tracking-[0.2em] text-zinc-600">
        <span>© {year} MTK SYSTEM · XOEL CRESPO</span>
        <span>{t.footer.rights}</span>
      </div>
    </footer>
  );
}
